import React, { ReactElement, PropsWithChildren } from 'react';
import classNames from 'classnames';

export type FormGroupTextProps = PropsWithChildren<{
  className?: string;
  testId?: string;
}>;

export function FormGroupText({
  children,
  className = '',
  testId,
}: FormGroupTextProps): ReactElement {
  const classes = classNames('form-group__text', className);
  return (
    <div className={classes} data-testid={testId}>
      {children}
    </div>
  );
}
